<!-- 
   author: 李小龙 
   time:2023/04/28
   eg:网站头部信息
  -->
<template>
  <div class="header">
    <div class="header-up" style="width: 100% !important">
      <div class="headerup-content" style="display: flex">
        <div style="height: 80px; padding: 5px">
          <img src="@/assets/logo.png" style="height: 100%; margin-left: 0px" />
        </div>
        <div style="display: flex; width: 100%; justify-content: right">
          <div class="header-menu" style="display: flex; padding: 1px">
            <div style="padding: 12px; cursor: pointer" @click="forkliftList">
              <span class="header-fontMenuChild">
                <span style="color: red">{{ num }}</span> 
                {{ $t("top.库里的叉车") }}
                </span>
            </div>
            <div style="padding: 12px; cursor: pointer" @click="forkliftListOnWay">
              <span class="header-fontMenuChild">
                <span style="color: red">{{ numOnWay }}</span> 
                {{ $t("top.在途的叉车") }}
                </span>
            </div>
            <div style="padding: 12px; cursor: pointer" @click="accessoriy">
              <span class="header-fontMenuChild">{{ $t("top.叉车属具") }}</span>
            </div>
            <div style="padding: 12px; cursor: pointer" @click="news">
              <span class="header-fontMenuChild">{{ $t("top.新闻中心") }}</span>
            </div>
            <div style="padding: 12px; cursor: pointer" @click="about">
              <span class="header-fontMenuChild">{{ $t("top.公司介绍") }}</span>
            </div>
            <div style="padding: 12px; cursor: pointer" cursor: pointer @click="contact">
              <span class="header-fontMenuChild">{{ $t("top.联系我们") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-bottom" style="display: flex">
      <div style="width: 500px; padding: 10px">
        <span class="header-buttomfont">{{ $t("top.电话") }}</span
        ><span class="header-buttomnumberfont" style="color: #04af04"
          >+86 13504428433</span
        >
        <span class="header-buttomfont">刘辉</span>
        
        <img
         @click="openWx"
          width="45px"
          style="
            border-radius: 50%;
            margin-left: 5px;
            padding: 8px;
            cursor:pointer;
          "
          height="45px"
          src="@/assets/wx.png"
        />
       <a href="mailto:sales@jfrental.com?subject=邮件主题！&body=邮件正文">
        <img
          width="45px"
          style="
            border-radius: 50%;
            margin-left: -12px;
            padding: 8px;
             cursor:pointer;
          "
          height="45px"
          src="@/assets/email.png"
        />
        </a>
         <img
         @click="openWhatsapp('8613504428433')"
          width="45px"
          style="
            border-radius: 50%;
            margin-left: -12px;
            padding: 8px;
             cursor:pointer;
          "
          height="45px"
          src="@/assets/whatsapp.png"
        />
      </div>
      <div
        style="
          display: flex;
          flex: 1;
          justify-content: right;
          align-items: right;
          padding: 30px;
        "
      >
        <!-- 三张scg图片 -->
        <div
          style="
            display: flex;
            justify-content: right;
            padding-right: 15px;
            color: rgb(255, 166, 10);
            align-items: center;
          "
        >
          <a-badge
            :count="$store.state.favoriteList.length"
            :numberStyle="{ height: '20px' }"
          >
            <div
              style="
                width: 35px;
                height: 35px;
                background-color: transparent;
                border: solid 1px black;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
              "
            >
              <img
                width="32px"
                style="border-radius: 50%"
                height="32px"
                src="@/assets/shoucang.png"
                @click="favorite"
              />
            </div>
          </a-badge>
          <div style="margin-left: 15px; color: black">{{ $t("top.收藏") }}</div>
        </div>
        <div
          style="
            display: flex;
            justify-content: right;
            padding-right: 15px;
            align-items: center;
            color: rgb(255, 166, 10);
          "
        >
          <a-badge
            :count="$store.state.bijiaoList.length"
            :numberStyle="{ height: '20px' }"
          >
            <div
              style="
                width: 35px;
                height: 35px;
                background-color: transparent;
                border: solid 1px black;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
              "
            >
              <img
                width="32px"
                style="border-radius: 50%; cursor: hand"
                height="32px"
                src="@/assets/tp.png"
                @click="compare"
              />
            </div>
          </a-badge>
          <div style="margin-left: 15px; color: black">{{ $t("top.比较") }}</div>
        </div>
        <div
          style="
            display: flex;
            justify-content: right;
            padding-right: 15px;
            align-items: center;
            color: rgb(255, 166, 10);
          "
        >
          <a-badge :numberStyle="{ height: '20px' }">
            <div
              style="
                width: 35px;
                height: 35px;
                background-color: transparent;
                border: solid 1px black;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
              "
            >
              <img
                width="32px"
                style="border-radius: 50%; cursor: hand"
                height="32px"
                src="@/assets/login.png"
                @click="login"
              />
            </div>
          </a-badge>
          <div  style="margin-left: 15px; width: 50px; color: black">
             <div v-if="Object.keys(this.$store.state.userInfo).length > 0">{{ $store.state.userInfo.name }}</div>
             <div v-else>{{ $t("top.登录") }}</div>
          </div>
          <div
            style="
              display: flex;
              justify-content: right;
              padding-right: 5px;
              color: rgb(255, 166, 10);
              align-items: center;
              cursor: pointer;
            "
          >
              <a-dropdown>
      <a-menu slot="overlay" style="border-color: black;">
        <a-menu-item key="1" @click="langzh" style="color: black;">
           <img src="@/assets/china.png" width="20" height="20">
      <span>中文</span>
        </a-menu-item>
        <a-menu-item key="2" @click="langen" style="color: black;">
          <img src="@/assets/usa.png" width="20" height="20">
      <span>English</span></a-menu-item>
      </a-menu>
      <a-button style="margin-left: 8px; color: black;">  
        <img src="@/assets/usa.png" width="20" height="20" v-if="$i18n.locale=='en'">
        <img src="@/assets/china.png" width="20" height="20"  v-if="$i18n.locale=='zh'"> {{ $t("top.语言") }}  <a-icon type="down" /> </a-button>
    </a-dropdown>

            <!-- <img
              width="32px"
              style="border-radius: 50%; margin-left: 10px"
              height="32px"
              src="@/assets/zh.png"
              @click="langzh"
            />
             <img
              width="32px"
              style="border-radius: 50%; margin-left: 10px"
              height="32px"
              src="@/assets/meiguo.png"
              @click="langen"
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import en from "@/i18n/lang/en";
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      imageUrl: "",
      num: "0",
      numOnWay: "0",
      imageUrlLogo: "Images/logo.png",
    };
  },
  mounted() {
    this.forklift();
    this.forkliftOnWay();
  },
  created() {
    // var uName = $store.state.message; //JSON.parse(localStorage.getItem("userJson"));
  },
  methods: {
    openWhatsapp(phoneNumberWithCountryCode) {
      var whatsappURL = `https://wa.me/${phoneNumberWithCountryCode}`;
      var win = window.open(whatsappURL, "_blank");
      if (win) {
        // 如果成功打开，win将不会为null
        win.focus();
      } else {
        // 如果无法打开，可以尝试使用下面的代码在新标签页中打开链接
        //  this.$notification.error({
        //       message: "wgatsApp",
        //       description: "whatsApp打开失败!",
        //     });
      }
    },
    openEmail() {},
    openWx() {
      const imageUrl =
        "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/weixinopen.jpg";
      window.open(imageUrl, "_blank");
    },
    langzh() {
      this.$i18n.locale = "zh";

      // this.imageUrl="@/assets/china.png";
    },
    langen() {
      this.$i18n.locale = "en";
      // this.imageUrl="@/assets/usa.png";
    },
    //设置top文件点击得路由信息
    forklift() {
      axios
        .post(this.$apiUrl + "/api/general/queryAction", {
          actionName: "getAssetReport",
          filters: {
            queryFilter: [
              {
                dataIndex: "type",
                operator: "eq",
                value: "车辆设备",
              },
              {
                dataIndex: "stateMsg",
                operator: "eq",
                value: "在库",
              },
            ],
          },
        })
        .then((res) => {
          let temp = res.data.total;
          this.num = temp;
        });
    },
    forkliftOnWay() {
      axios
        .post(this.$apiUrl + "/api/general/queryMulti", {
          tableName: "jf_asset_purchase_order",
          filters: {
            queryFilter: [
              {
                dataIndex: "state",
                operator: "neq",
                value: -1,
              },
              {
                dataIndex: "state",
                operator: "neq",
                value: 1,
              },
              {
                dataIndex: "state",
                operator: "neq",
                value: 6,
              },
              {
                dataIndex: "type",
                operator: "eq",
                value: "车辆设备",
              },
            ],
          },
        })
        .then((res) => {
          this.numOnWay = res.data.total;
        });
    },
    login() {
      if (Object.keys(this.$store.state.userInfo).length == 0) {
        this.$router.push({ path: "/login" });
      } else {
        this.$router.push({ path: "/userInfo" });
      }
    },
    compare() {
      if (this.$store.state.bijiaoList.length > 0) {
        this.$router.push({ path: "/compare" });
      } else {
        this.$notification.error({
          message: "比较",
          description: "没有加入比较得叉车!",
        });
      }
    },
    news() {
      this.$router.push({ path: "/newsList" });
    },
    about() {
      this.$router.push({ path: "/AboutView" });
    },
    accessoriy() {
      this.$router.push({ path: "/accessoriyList" });
    },
    favorite() {
      if (this.$store.state.favoriteList.length > 0) {
        this.$router.push({ path: "/favorite" });
      } else {
        this.$notification.error({
          message: "收藏",
          description: "没有加入收藏得叉车!",
        });
      }
    },
    contact() {
      this.$router.push({ path: "/contact" });
    },
    forkliftList() {
      this.$router.push({ path: "/forkliftList" });
    },
    forkliftListOnWay() {
      this.$router.push({ path: "/forkliftListOnWay" });
    },
  },
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: white;
  z-index: 1000; /* 确保头部在最上层 */
}
.header-fontMenuChild {
  font-size: 25px;
  color: #ffffff;
  font-weight: bold;
  margin-left: 20px;
}
.header-buttomfont {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  margin: 0 auto;
  font-weight: 700;
  margin-left: 15px;
  padding: 0px;
  float: left;
  overflow: hidden;
}
.header-buttomnumberfont {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  margin: 0 auto;
  font-weight: 700;
  margin-left: 5px;
  padding: 0px;
  float: left;
  overflow: hidden;
}
.header-up {
  min-height: 85px;
  height: 85px;
  background: #0067b3;
  border: none;
}
.header-bottom {
  min-height: 55px;
  height: 55px;
  width: 100%;
  background: #ececec !important;
}
.headerup-content {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.header-menu {
  padding-right: 15px;
  padding-left: 15px;
}
</style>
